import styled from '@emotion/styled';
import { Checkbox, createTheme, Divider, FormControl, FormControlLabel, Grid, Radio, Stack, TextField } from '@mui/material';
import React from 'react'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCustomForm } from '../../../hooks/useCustomForm';
import { BodyContainer } from '../../containers/BodyContainer'
import { MainButton, MainInput, SubTitle, Title } from '../../helpers';
import logo from '../../../assets/images/logo.png'
import { customStyles } from '../../../styles';
import { useDispatch, useSelector } from 'react-redux';
import { signUpAction } from '../../../actions/loginActions';
import { useEffect } from 'react';
import GoogleLogin from 'react-google-login';
import { gapi } from 'gapi-script';
import ReactFacebookLogin from 'react-facebook-login';
import { animations } from '../../../utils/animations';
import { setTologOrRegister } from '../../../slices/LoginSlice';


export const RegisterForm = () => {
   const navigate = useNavigate()
   const { token } = useSelector(state => state.apiToken)
   const { recieveCode } = useSelector(state => state.login)
   const { inputValues, handleOnChange, resetForm, setNewValues } = useCustomForm({ 
      name: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      code: '',
      confirmCode: '',
      method: 'password'
    })
    const clientId = process.env.REACT_APP_GOOGLE_AUTH
    const clientId_f = process.env.REACT_APP_FACEBOOK_LOGIN
    const [transition, setTransition] = useState(false)
    const dispatch = useDispatch()
    const [agree, setAgree] = useState(true)
    const [authAccess, setAuthAccess] = useState(null)

    const handleBackward = (e) => {
      // e.preventDefault()
      navigate(-1)
    }
    const handleAggre = () => {
      setAgree(!agree)
    }

    const onSubmit = (e) => {
      dispatch(setTologOrRegister(false))
      e.preventDefault()
      if(name.length > 2 && lastName.length > 2&& email.length > 5 && code.length > 4 && code === confirmCode) {
        // let method = !inputValues?.method ? 'password' : inputValues.method
        // method = inputValues?.method && inputValues.method
        const newForm = { ...inputValues, phone: phoneNumber, lastname: lastName, key: code }
        dispatch(signUpAction(newForm, token))
      }
    }
   const { name, lastName, email, phoneNumber, code, confirmCode } = inputValues
    
    const onSuccess = ({profileObj}) => {
      setTransition(true)
      setAuthAccess(profileObj)
      setNewValues({
        name: profileObj.givenName,
        lastName: profileObj.familyName,
        email: profileObj.email,
        phone: '',
        code: profileObj.googleId,
        confirmCode: profileObj.googleId,
        method: 'google'
      })

    }

    const LoginFacebook = (resp) => {
      setTransition(true)
      setAuthAccess(resp)
      setNewValues({
        name: resp.name.split(' ')[0],
        lastName: resp.name.split(' ')[1],
        email: resp.email,
        phone: '',
        code: resp.userID,
        confirmCode: resp.userID,
        method: resp.graphDomain
      })
    }

    const onFailure = () => {
      console.log("fail connection")
    }
    useEffect(() => {
      resetForm()
    }, [])

   useEffect(() => {
    recieveCode && navigate('/code')
   }, [recieveCode])

   useEffect(() => {
    transition && setTransition(false)
   }, [transition])
  return (
    <BodyContainer  sx={{height: '80vh', marginTop: 5}}>
      <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
          <SubTitle text="Registro" color={customStyles.colors.main}/>
        <figure style={{ display: 'flex', justifyContent: 'start', marginBottom: 30 }}>
          <img src={logo} alt="global gas" style={{
            width: '50px',
          }}/>
        </figure>
      </Stack>
      <FormControl sx={{minWidth: 360}} onSubmit={onSubmit} className={ !transition ? animations.fadeIn : animations.fadeOut }>
         <Stack spacing={3}>
            <MainInput label="Nombre" name="name" onChange={handleOnChange} value={name} fullWidth/>

            <MainInput label="Apellidos" name="lastName" onChange={handleOnChange} value={lastName} fullWidth/>
            <MainInput label="Correo electrónico" name="email" onChange={handleOnChange} value={email} fullWidth/>
            <MainInput label="Telefono" name="phoneNumber" onChange={handleOnChange} value={phoneNumber} fullWidth/>
            
              { !authAccess && 
                <>
                  <MainInput label="Contraseña" name="code" onChange={handleOnChange} type="password" value={code} fullWidth/>
                  <MainInput label="Confirmar contraseña" name="confirmCode" type="password" onChange={handleOnChange} value={confirmCode} fullWidth/>  
                </>
              }

            <FormControlLabel value="acuerdo" control={<Checkbox onClick={handleAggre}/>} label="Estoy deacuerdo terminos y condiciones " />
            <Stack direction="row" spacing={3}>
               <MainButton variant="outlined" text="Cancelar" size="100%" onClick={handleBackward}/>
               <MainButton variant="contained" text="Siguiente" size="100%" disabled={agree} onClick={onSubmit}/>
            </Stack>
         </Stack>
         
               {/* IMPLEMENT IN THE FUTURE */}

         {/* <Divider sx={{ margin: '30px 0', display: 'flex', alignItems: 'center' }}>O registrate con</Divider>
         <Stack direction="row" spacing={3} justifyContent="center">
          <GoogleLogin 
              clientId={clientId}
              onSuccess={onSuccess}
              onFailure={onFailure}
              cookiePolicy={"single_host_policy"}
              buttonText="Google"
              className='social-login google--bg'
              icon={false}

              // style={{ borderRadius: 5, border: '1px solid red' }}
            />
          <ReactFacebookLogin
            appId={clientId_f}
            autoLoad={false}
            fields="name,email,picture"
            textButton='Facebook'
            cssClass='social-login facebook--bg'
            // onClick={LoginFacebook}
            callback={LoginFacebook} 
            />
         </Stack> */}
      </FormControl>
    </BodyContainer>
  )
}
